"use strict";

// console.info('Hello world');

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Import des styles CSS directement dans le JS (Webpack s'occupe du reste)
import 'swiper/css';
import 'swiper/css/navigation';

let width = screen.width;

document.addEventListener('DOMContentLoaded', () => {

  // 1. CONFIGURATION DES SÉLECTEURS (Variables propres)
  const headerTarget = document.querySelector('.header');
  const footerTarget = document.querySelector('.footer');
  const activeClass = 'link-menu--active';

  // 2. INJECTION DU HEADER
  if (headerTarget) {
    fetch('header.html')
      .then(response => response.text())
      .then(htmlContent => {
        // On injecte ton menu dans la classe .header
        headerTarget.innerHTML = htmlContent;

        // Gestion du lien actif de la navigation
        const currentPage = window.location.pathname.split("/").pop();
        const pageName = currentPage === "" ? "index.html" : currentPage;

        // On cherche le lien correspondant dans le header qu'on vient d'injecter
        const activeLink = headerTarget.querySelector(`.link-menu[href="${pageName}"]`);
        if (activeLink) {
          activeLink.classList.add(activeClass);
        }

        // /!\ CRUCIAL : On active le Burger SEULEMENT maintenant que le HTML existe
        initBurgerMenu();
      })
      .catch(error => console.error("Erreur lors du chargement du header :", error));
  }

  // 3. INJECTION DU FOOTER
  if (footerTarget) {
    fetch('footer.html')
      .then(response => response.text())
      .then(htmlContent => {
        footerTarget.innerHTML = htmlContent;
      })
      .catch(error => console.error("Erreur lors du chargement du footer :", error));
  }

  // 4. FONCTION POUR TON MENU BURGER
  function initBurgerMenu() {
    // On récupère la largeur de l'écran en pixels
    const width = window.innerWidth;

    // On applique ta condition de responsive (uniquement sous les 1024px)
    if (width < 1024) {
      const menuBurger = document.querySelector('.menu__burger');
      const menuSpan = document.querySelector('.menu__burger span');
      const navLinks = document.querySelectorAll('.menu-links__list li a');

      // Sécurité : on vérifie que le menuBurger existe bien avant de mettre les écouteurs
      if (menuBurger) {
        menuBurger.addEventListener('click', toggleNavigation);

        // Au clic sur n'importe quel lien du menu, on referme le rideau
        navLinks.forEach(link => link.addEventListener('click', toggleNavigation));
      }

      // Ta fonction d'origine pour ouvrir/fermer
      function toggleNavigation() {
        if (document.body.hasAttribute("data-menu")) {
          document.body.removeAttribute("data-menu");
          if (menuSpan) menuSpan.innerHTML = "Menu";
          document.body.classList.remove("disable-scrolling");
        } else {
          document.body.setAttribute("data-menu", true);
          if (menuSpan) menuSpan.innerHTML = "Close";
          document.body.classList.add("disable-scrolling");
        }
      }
    }
  }

});

document.addEventListener("DOMContentLoaded", () => {
  const carrouselExiste = document.querySelector(".mySwiper");

  if (carrouselExiste) {
    const swiper = new Swiper(".mySwiper", {
      modules: [Navigation],

      // 🚀 LE CHANGEMENT EST ICI : On passe en "auto" pour que Swiper lise ton CSS
      slidesPerView: "auto",

      spaceBetween: 20,
      grabCursor: true,
      simulateTouch: true,

      navigation: {
        // Remets bien ici les classes de tes boutons (soit tes customs, soit ceux de swiper)
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {

  const videoContainer = document.querySelector('.video-container');
  const video = document.getElementById('project-video');

  // 🚀 2. CONDITION : On exécute le code UNIQUEMENT si les deux éléments existent sur la page
  if (videoContainer && video) {

    function togglePlay() {
      if (video.paused) {
        video.play();
        videoContainer.classList.add('is-playing');
      } else {
        video.pause();
        videoContainer.classList.remove('is-playing');
      }
    }

    // On écoute le clic sur le conteneur
    videoContainer.addEventListener('click', togglePlay);

    // On écoute la fin de la vidéo
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      videoContainer.classList.remove('is-playing');
      video.load(); // Recharge le poster
    });

  }

});


/* btn calendar */
const trigger = document.getElementById('calendar-trigger');
const menu = document.getElementById('calendar-menu');

// Ouvre/Ferme au clic sur le bouton
if (trigger) {
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    menu.classList.toggle('is-open');
});
};

// Ferme le menu si on clique n'importe où ailleurs sur la page
if (menu) {
  document.addEventListener('click', () => {
    menu.classList.remove('is-open');
});
};



// ==========================================
// 1. SÉLECTION DES ÉLÉMENTS DU DOM
// ==========================================
const zoomSlider = document.querySelector('.worldControls__slider');
const activeLabel = document.getElementById('active-label');
const tooltip = document.querySelector('.world__tooltip');
const infoCard = document.getElementById('info-card');
const cardImage = document.getElementById('card-image');
const cardTitle = document.getElementById('card-title');
const cardDescription = document.getElementById('card-description');
const cardLocation = document.getElementById('card-location');
const cardUrl = document.getElementById('card-url');

const btnViewMap = document.getElementById('btn-view-map');
const btnViewList = document.getElementById('btn-view-list');
const mapSection = document.querySelector('.world');
const listSection = document.querySelector('.womenList');
const listFooter = document.querySelector('.footer-container');

// NOUVEAU : Variables de sécurité ("Flags")
let isMapAnimating = false; // Vrai quand la carte bouge toute seule (après un clic)
let isUserDragging = false; // Vrai quand l'utilisateur déplace la carte manuellement

if (mapSection) {

  // ==========================================
// 2. TOGGLE CARTE / LISTE
// ==========================================
if (btnViewMap && btnViewList && mapSection && listSection) {
    btnViewList.addEventListener('click', function () {
        btnViewMap.classList.remove('viewToggle__btn--active');
        btnViewList.classList.add('viewToggle__btn--active');
        mapSection.classList.add('u-hidden');
        listSection.classList.remove('u-hidden');
        listFooter.classList.remove('u-hidden');
    });

    btnViewMap.addEventListener('click', function () {
        btnViewList.classList.remove('viewToggle__btn--active');
        btnViewMap.classList.add('viewToggle__btn--active');
        listSection.classList.add('u-hidden');
        listFooter.classList.add('u-hidden');
        mapSection.classList.remove('u-hidden');

        if (typeof mapPanZoom !== 'undefined') { mapPanZoom.resize(); }
    });
}

// ==========================================
// 3. INITIALISATION DE LA CARTE (SVG-PAN-ZOOM)
// ==========================================
const mapPanZoom = svgPanZoom('.world__map', {
    zoomEnabled: true,
    controlIconsEnabled: false,
    fit: true,
    center: true,
    minZoom: 1,
    maxZoom: 10,
    zoomScaleSensitivity: 0.2,
    mouseWheelZoomEnabled: true,

    beforePan: function (oldPan, newPan) {
        const sizes = this.getSizes();
        const margin = 0.2;
        const minX = -sizes.viewBox.width * sizes.realZoom * (1 - margin);
        const maxX = sizes.width - (sizes.viewBox.width * sizes.realZoom * margin);
        const minY = -sizes.viewBox.height * sizes.realZoom * (1 - margin);
        const maxY = sizes.height - (sizes.viewBox.height * sizes.realZoom * margin);

        return {
            x: Math.max(minX, Math.min(maxX, newPan.x)),
            y: Math.max(minY, Math.min(maxY, newPan.y))
        };
    },

    onZoom: function (newZoom) {
        if (zoomSlider) { zoomSlider.value = newZoom; }
        // On cache le pin UNIQUEMENT si c'est un zoom manuel de l'utilisateur
        if (!isMapAnimating && activeLabel) {
            activeLabel.classList.remove('visible');
        }
    },

    onPan: function () {
        // La carte bouge : on signale que l'utilisateur fait un glissement (Drag)
        isUserDragging = true;

        // On cache le pin UNIQUEMENT si c'est un déplacement manuel
        if (!isMapAnimating && activeLabel) {
            activeLabel.classList.remove('visible');
        }
    }
});

// ==========================================
// 4. CONTRÔLES MANUELS
// ==========================================
if (zoomSlider) {
    zoomSlider.addEventListener('input', function (e) { mapPanZoom.zoom(parseFloat(e.target.value)); });
}
const btnZoomIn = document.querySelector('.worldControls__btn--in');
if (btnZoomIn) {
    btnZoomIn.addEventListener('click', function (e) { e.preventDefault(); mapPanZoom.zoomIn(); });
}
const btnZoomOut = document.querySelector('.worldControls__btn--out');
if (btnZoomOut) {
    btnZoomOut.addEventListener('click', function (e) { e.preventDefault(); mapPanZoom.zoomOut(); });
}

// ==========================================
// 5. CHARGEMENT JSON & GÉNÉRATION LISTE
// ==========================================
fetch('./scripts/data.json')
    .then(response => response.json())
    .then(data => {
        initInteractiveCountries(data);
        generateWomenList(data);
    })
    .catch(error => console.error("Erreur JSON :", error));

function generateWomenList(data) {
    const container = document.getElementById('women-cards-container');
    if (!container) return;
    console.log("caca");

    Object.values(data).forEach(woman => {
        const card = document.createElement('article');
        card.classList.add('womanCard');
        card.innerHTML =
        `
            <a class="swiper-slide__card" href="${woman.url}">
            <img class="card-image" src="${woman.url_image}">
            <h3 class="title title--mini">${woman.nom}</h3>
            <p class="text">"${woman.description}”</p>
            <p class="text text--little">${woman.pays}| ${woman.ville}</p>
          </a>
        `;
        container.appendChild(card);
    });
}

// ==========================================
// 6. FONCTION PAYS INTERACTIFS
// ==========================================
function initInteractiveCountries(data) {
    const activatedCountries = Object.keys(data);

    activatedCountries.forEach(isoCode => {
        const country = document.getElementById(isoCode);
        const countryData = data[isoCode];

        if (country) {
            country.classList.add("interactive");

            country.addEventListener('mouseenter', function () {
                if (country.classList.contains('is-active')) return;
                tooltip.textContent = countryData.pays;
                tooltip.classList.add('visible');
            });

            country.addEventListener('mousemove', function (e) {
                // On bloque l'infobulle si le pays est déjà cliqué
                if (country.classList.contains('is-active')) return;

                // 1. On récupère la position exacte de la carte sur l'écran
                const svgRect = document.querySelector('.world__map').getBoundingClientRect();

                // 2. On calcule la position de la souris UNIQUEMENT à l'intérieur de la carte
                const localX = e.clientX - svgRect.left;
                const localY = e.clientY - svgRect.top;

                // 3. On applique la position avec tes petits ajustements (le doigt)
                tooltip.style.left = (localX - 0) + 'px';
                tooltip.style.top = (localY - 9) + 'px';
            });

            country.addEventListener('mouseleave', function () {
                tooltip.classList.remove('visible');
            });

            country.addEventListener('click', function (e) {
                e.stopPropagation();

                // SÉCURITÉ : Si l'utilisateur était juste en train de glisser la carte, on bloque le clic !
                if (isUserDragging) return;

                // On active la protection pour le zoom/déplacement qui va suivre
                isMapAnimating = true;

                document.querySelectorAll('.interactive').forEach(c => c.classList.remove('is-active'));
                country.classList.add('is-active');
                tooltip.classList.remove('visible');

                cardTitle.textContent = countryData.nom;
                cardDescription.textContent = countryData.description;
                cardImage.src = countryData.url_image;
                cardImage.alt = `Portrait de ${countryData.nom}`;
                cardUrl.href = countryData.url;
                cardLocation.textContent = `${countryData.pays} | ${countryData.ville}`;
                infoCard.classList.add('world__card--visible');

                const svgRect = document.querySelector('.world__map').getBoundingClientRect();
                const localX = e.clientX - svgRect.left;
                const localY = e.clientY - svgRect.top;

                const currentZoom = mapPanZoom.getZoom();
                const currentPan = mapPanZoom.getPan();

                const internalX = (localX - currentPan.x) / currentZoom;
                const internalY = (localY - currentPan.y) / currentZoom;

                const targetZoom = 5;
                mapPanZoom.zoom(targetZoom);

                const sizes = mapPanZoom.getSizes();
                const offsetDroit = 170;

                const desiredPanX = (sizes.width / 2) + offsetDroit - (internalX * targetZoom);
                const desiredPanY = (sizes.height / 2) - (internalY * targetZoom);

                mapPanZoom.pan({ x: desiredPanX, y: desiredPanY });

                activeLabel.textContent = countryData.pays;

                const realPan = mapPanZoom.getPan();
                const realZoom = mapPanZoom.getZoom();
                const scrollX = window.scrollX || window.pageXOffset;
                const scrollY = window.scrollY || window.pageYOffset;

                const actualScreenX = (internalX * realZoom) + realPan.x;
                const actualScreenY = (internalY * realZoom) + realPan.y;

                const finalX = svgRect.left + scrollX + actualScreenX;
                const finalY = svgRect.top + scrollY + actualScreenY;

                activeLabel.style.left = finalX + 'px';
                activeLabel.style.top = (finalY - 15) + 'px';
                activeLabel.classList.add('visible');

                // On désactive la protection au bout de 50ms (le temps que l'animation finisse)
                setTimeout(() => { isMapAnimating = false; }, 50);
            });
        }
    });
}

// ==========================================
// 7. SÉCURITÉS ANTI-CONFLIT (DRAG VS CLIC)
// ==========================================

// À chaque fois qu'on clique au départ (sans relâcher), on remet le "glissement" à zéro
document.addEventListener('pointerdown', function () {
    isUserDragging = false;
});

if (infoCard) {
    infoCard.addEventListener('click', function (e) {
        e.stopPropagation();
    });
}

document.addEventListener('click', function (event) {
    // MAGIE ICI : Si l'utilisateur a glissé la souris (drag), on annule totalement le faux clic !
    if (isUserDragging) return;

    const isCardVisible = infoCard && infoCard.classList.contains('world__card--visible');
    // On utilise closest() au cas où l'utilisateur clique sur le tracé interne <path> du SVG
    const isCountryClick = event.target.closest('.interactive');

    if (isCardVisible && !isCountryClick) {
        infoCard.classList.remove('world__card--visible');
        if (activeLabel) activeLabel.classList.remove('visible');
        document.querySelectorAll('.interactive').forEach(c => c.classList.remove('is-active'));
    }
});

 // ==========================================
    // 8. SÉCURITÉ RESPONSIVE (MOBILE)
    // ==========================================
    // On vérifie la largeur de la fenêtre (1024px est ton point de rupture pour les tablettes/mobiles)
    if (window.innerWidth < 1024) {
        // On simule un clic direct sur le bouton "Liste" au démarrage.
        // Cela permet à svgPanZoom de s'initialiser correctement AVANT d'être caché !
        if (btnViewList) {
            btnViewList.click();
            document.querySelector(".world").classList.add('u-hidden');
            document.querySelector(".viewToggle").classList.add('u-hidden');
            listSection.classList.remove('u-hidden');
            listFooter.classList.remove('u-hidden');

        }
    }

};
